var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "loading-bar rounded-border",
      staticStyle: {
        display: "flex",
        "flex-direction": "column",
        padding: "30px",
        width: "100%",
        height: "max-content"
      }
    },
    [
      _c(
        "span",
        {
          staticStyle: {
            display: "flex",
            color: "#003333",
            "justify-content": "center",
            "align-items": "center",
            "margin-bottom": "20px"
          }
        },
        [_vm._v(_vm._s(_vm.loadingText || "Loading..."))]
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 18 } },
            [
              _c(
                "el-row",
                {
                  staticClass: "rounded-border",
                  staticStyle: {
                    height: "200px",
                    width: "100%",
                    "background-color": "#cccccc",
                    "margin-bottom": "10px"
                  },
                  attrs: { gutter: 20 }
                },
                [_c("el-col", { attrs: { span: 24 } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticClass: "rounded-border",
                  staticStyle: {
                    height: "30px",
                    width: "100%",
                    "background-color": "#cccccc",
                    "margin-bottom": "10px"
                  },
                  attrs: { gutter: 20 }
                },
                [
                  _c("el-col", { attrs: { span: 12 } }),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 12 } })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticClass: "rounded-border",
                  staticStyle: {
                    height: "40px",
                    width: "100%",
                    "background-color": "#cccccc",
                    "margin-bottom": "10px"
                  },
                  attrs: { gutter: 20 }
                },
                [
                  _c("el-col", { attrs: { span: 12 } }),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 12 } })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticClass: "rounded-border",
                  staticStyle: {
                    height: "200px",
                    width: "100%",
                    "background-color": "#cccccc"
                  },
                  attrs: { gutter: 20 }
                },
                [
                  _c("el-col", { attrs: { span: 12 } }),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 12 } })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-row",
                {
                  staticClass: "rounded-border",
                  staticStyle: {
                    height: "500px",
                    width: "100%",
                    "background-color": "#cccccc"
                  }
                },
                [_c("el-col", { attrs: { span: 24 } })],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f3e7000", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f3e7000","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/loadingSkeleton.vue
// module id = null
// module chunks = 